import axios from 'axios'
import { getBaseUrl } from 'services/env'

export const apiClient = axios.create({
  baseURL: `${getBaseUrl()}/api/`,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const apiBackClient = axios.create({
  baseURL: `${process.env.APP_URI}/api/`,
  headers: {
    'Content-Type': 'application/json'
  }
})
